'use strict'

const _ = require('lodash')

/**
 * @exports utils/dataFixer/plugins/translatedRepeaterDataFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewer, rendererModel, magicObject) {
        const {isExperimentOpen} = magicObject
        if (!isExperimentOpen('dm_removeTranslatedRepeaterData')) {
            return
        }

        const translations = _.get(pageJson, 'translations', {})

        _.forEach(translations, translation => {
            const translationData = _.get(translation, ['data', 'document_data'], {})

            _.forEach(translationData, (dataItem, dataItemKey) => {
                if (dataItem.type === 'Repeater') {
                    delete translationData[dataItemKey]
                }
            })
        })
    }
}
